module.exports = __webpack_public_path__ + "img/empty.69c4832a.png";